import { ComponentPropsWithRef, ReactNode } from "react"
import { cn } from "styles/cn"

export const ShortcutLabel = ({
	className,
	label,
	shortcut,
	...props
}: ComponentPropsWithRef<"div"> & {
	label: ReactNode
	shortcut: ReactNode
}) => {
	return (
		<div
			{...props}
			className={cn("flex items-center justify-center gap-2", className)}
		>
			{label}
			<code className="font-nunito text-grey-40">{shortcut}</code>
		</div>
	)
}
